import { IconArrowLeft } from "theme/common/Icon.styled"
import { useHistory } from "react-router-dom"
import BackToDashboardButtonStyled from "./BackToDashboardButton.styled"

interface BackToDashboardButtonProps {
  onClickBackButton?: () => void
  text?: string
  path?: string
}

const BackToDashboardButton = ({ 
  onClickBackButton, 
  text = "Regresar a la Bandeja Principal",
  path = "/contractor/dashboard"
}: BackToDashboardButtonProps) => {
  const history = useHistory()

  const handleClickBackToDashboard = () => {
    history.push(path)
    onClickBackButton && onClickBackButton()
  }

  return (
    <BackToDashboardButtonStyled onClick={handleClickBackToDashboard}>
      <IconArrowLeft className="icon-back" />
      <span>{text}</span>
    </BackToDashboardButtonStyled>
  )
}

export default BackToDashboardButton

